import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';

const Svg = () => (
  <svg width="1em" height="1em" fill="currentColor" viewBox="-4 -4 8 8">
    <circle fill="gold" cx="0" cy="0" r="4" />
    <circle fill="yellow" cx="0" cy="0" r="3" />
  </svg>
);

const C3IIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
);


export default C3IIcon;